import { render, staticRenderFns } from "./npsTips.vue?vue&type=template&id=432e0b06&scoped=true&"
import script from "./npsTips.vue?vue&type=script&lang=js&"
export * from "./npsTips.vue?vue&type=script&lang=js&"
import style0 from "./npsTips.vue?vue&type=style&index=0&id=432e0b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e0b06",
  null
  
)

export default component.exports